import type { HelpFile } from '../../types/help'
import { MyResponsibilitiesTestIds, MyResponsibilitiesTabId } from '../../../testids/MyResponsibilitiesTestIds'

export const myResponsibilitiesHelp: HelpFile = {
  docPage: '/docs/my-iam/my-responsibilities',
  texts: {
    [MyResponsibilitiesTestIds.myResponsibilitiesOuterTabs]: null,
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.AccessProfiles)]:
      'Zugriffsprofile, für die Sie als Eigentümer oder Steward eingetragen sind — direkt oder über Team-Mitgliedschaft.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.FunctionGroups)]:
      'Funktionsgruppen, für die Sie als Eigentümer oder Steward eingetragen sind.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.Resources)]:
      'Ressourcen, für die Sie als Eigentümer oder Steward eingetragen sind.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.TargetSystems)]:
      'Zielsysteme, für die Sie als Eigentümer oder Steward eingetragen sind.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.RestrictionRules)]:
      'Restriktionsregeln, für die Sie als Eigentümer oder Steward eingetragen sind.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.AutoAssignRules)]:
      'Auto-Zuweisungsregeln, für die Sie als Eigentümer oder Steward eingetragen sind.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.CertificationPolicies)]:
      'Zertifizierungsrichtlinien, für die Sie als Eigentümer oder Steward eingetragen sind.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.CertificationCampaigns)]:
      'Zertifizierungskampagnen, für die Sie als Eigentümer oder Steward eingetragen sind.',
    _section:
      'Katalog-Entitäten, für die Sie als Eigentümer oder Steward eingetragen sind. Es werden nur aktuell gültige Verantwortlichkeiten (innerhalb ihres Gültigkeitsfensters) angezeigt.',
  },
}
